export default __webpack_public_path__ + "static/2-565a7c74540f700197eee9d2f6216d0b.jpg";